module.exports = __webpack_public_path__ + "static/media/object.dff6a019.png";